import { useEffect, useState } from 'react';
import SEO from '../components/SEO';

const gates = [
  {
    id: 'tiha-psiha',
    title: 'Tiha Psiha',
    descriptionEn:
      'A space for psychological, experiential and symbolic work — through encounter, body, sound, group process and inner imagery.',
    descriptionSr:
      'Prostor za psihološki, iskustveni i simbolički rad — kroz susret, telo, zvuk, grupu i unutrašnje slike.',
    page: '/tiha-psiha',
    closedImage: '/gates/tiha-closed.png',
    halfImage: '/gates/tiha-half.png',
    openImage: '/gates/tiha-open.png',
    theme: 'tiha',
  },
  {
    id: 'zoom-maestra',
    title: 'Zoom Maestra',
    descriptionEn:
      'A space for facilitators, educators and therapists who need calm, precise and reliable support for online and hybrid events.',
    descriptionSr:
      'Prostor za facilitatore, edukatore i terapeute kojima je potrebna mirna, precizna i pouzdana podrška za online i hibridne događaje.',
    page: '/zoom-maestra',
    closedImage: '/gates/zoom-closed.png',
    halfImage: '/gates/zoom-half.png',
    openImage: '/gates/zoom-open.png',
    theme: 'zoom',
  },
];

export default function HomePage({ setCurrentPage, t, language = 'en' }) {
  const [activeGate, setActiveGate] = useState(null);
  const isSerbian = t.nav.home === 'Početak';
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(hover: none), (pointer: coarse)');

    const updateDeviceType = () => {
      setIsTouchDevice(mediaQuery.matches);
    };

    updateDeviceType();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateDeviceType);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', updateDeviceType);
      }
    };
  }, []);

  const handleMouseEnter = (gateId) => {
    if (!isTouchDevice) {
      setActiveGate(gateId);
    }
  };

  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setActiveGate(null);
    }
  };

 const handleGateClick = (gate) => {
  if (!isTouchDevice) {
    setCurrentPage(gate.page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  if (activeGate === gate.id) {
    setCurrentPage(gate.page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  setActiveGate(gate.id);
};

  const handleGateKeyDown = (event, gate) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();

    setCurrentPage(gate.page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

  return (  <>
    <SEO
  title={
    language === 'sr'
      ? 'Tiha Psiha & Zoom Maestra | Psihologija, iskustveni rad i online podrška'
      : 'Tiha Psiha & Zoom Maestra | Psychology, Experiential Work & Online Event Support'
  }
  description={
    language === 'sr'
      ? 'Dve kapije: Tiha Psiha za psihološki, iskustveni i zvučni rad, i Zoom Maestra za mirnu podršku online i hibridnim događajima.'
      : 'Two pathways: Tiha Psiha for psychological, experiential and sound-based work, and Zoom Maestra for calm online and hybrid event support.'
  }
  url={
    language === 'sr'
      ? 'https://tihomira.info/sr'
      : 'https://tihomira.info/en'
  }
  language={language}
  alternateUrls={{
    en: 'https://tihomira.info/en',
    sr: 'https://tihomira.info/sr',
    xDefault: 'https://tihomira.info/en',
  }}
/>
    <main className="relative min-h-screen overflow-hidden bg-[#ddd7c8] text-[#182018]">
      <div className="pointer-events-none absolute inset-0">
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#ddd7c8_0%,#d8d1c2_48%,#d3ccbc_100%)]" />
      <div className="absolute inset-0 opacity-60 mix-blend-multiply bg-[radial-gradient(circle_at_18%_16%,rgba(255,255,255,0.42),transparent_28%),radial-gradient(circle_at_82%_22%,rgba(120,103,77,0.10),transparent_32%),radial-gradient(circle_at_24%_78%,rgba(115,98,73,0.08),transparent_36%),radial-gradient(circle_at_72%_72%,rgba(255,255,255,0.16),transparent_30%)]" />
      <div className="absolute inset-0 opacity-[0.12] mix-blend-soft-light bg-[linear-gradient(115deg,rgba(255,255,255,0.55),transparent_22%,rgba(122,105,78,0.16)_46%,transparent_70%,rgba(255,255,255,0.28))]" />
     </div>      
     <section className="relative px-6 pb-20 pt-16 sm:px-8 lg:px-12">
    <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_12%_10%,rgba(255,255,255,0.30),transparent_24%),radial-gradient(circle_at_84%_18%,rgba(124,108,81,0.10),transparent_28%),radial-gradient(circle_at_50%_100%,rgba(118,101,76,0.08),transparent_30%)]" />
        <div className="mx-auto mb-12 max-w-4xl text-center">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-[#6f6759]">
         tihomira.info
         </p>
        <h1 className="font-serif text-5xl font-normal leading-none text-[#172018] sm:text-6xl lg:text-6xl">
         {isSerbian ? 'Dve kapije' : 'Two Gates'}
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[#4f574d] sm:text-xl">
         {isSerbian
          ? 'Izaberi onu koja te vodi tamo gde ćeš naći ono što tražiš.'
          : 'Choose the one that leads you toward what you are looking for.'}
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
          {gates.map((gate) => {
            const isActive = activeGate === gate.id;

            return (
              <article
                key={gate.id}
                role="link"
                tabIndex={0}
                aria-expanded={isActive}
                aria-label={
                 language === 'sr'
               ? `Uđi u ${gate.title}`
               : `Enter ${gate.title}`
                }
                onMouseEnter={() => handleMouseEnter(gate.id)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleGateClick(gate)}
                onKeyDown={(event) => handleGateKeyDown(event, gate)}
                className={[
            'group relative min-h-[420px] cursor-pointer overflow-hidden rounded-[2rem] bg-[#ddd7c8] shadow-[0_18px_40px_rgba(67,58,41,0.10)] outline-none ring-1 ring-[#7c6f56]/8 transition-all duration-500 ease-out sm:min-h-[520px] lg:min-h-[560px]',
           'focus-visible:ring-4 focus-visible:ring-[#c7a65d] focus-visible:ring-offset-4',
           isActive ? '-translate-y-1' : '',
            ].join(' ')}
               >
              <img
  src={gate.closedImage}
  alt=""
  className={[
    'absolute inset-0 h-full w-full object-contain transition-all duration-500 ease-out',
    isActive
      ? 'scale-[1.02] opacity-0'
      : 'scale-100 opacity-100 group-hover:scale-[1.02] group-hover:opacity-0',
  ].join(' ')}
/>

<img
  src={gate.halfImage}
  alt=""
  className={[
    'absolute inset-0 h-full w-full object-contain transition-all duration-500 ease-out',
    isActive
      ? 'scale-[1.04] opacity-0'
      : 'scale-[1.02] opacity-0 group-hover:opacity-100',
  ].join(' ')}
/>

<img
  src={gate.openImage}
  alt=""
  className={[
    'absolute inset-0 h-full w-full object-contain transition-all duration-700 ease-out',
    isActive
      ? 'scale-[1.06] opacity-100'
      : 'scale-[1.03] opacity-0 group-hover:scale-[1.06] group-hover:opacity-100',
  ].join(' ')}
/>

                <img
                  src={gate.openImage}
                  alt=""
                  className={[
                  'absolute inset-0 h-full w-full object-contain mix-blend-multiply transition-all duration-700 ease-out',                    isActive
                      ? 'scale-[1.06] opacity-100'
                      : 'scale-[1.03] opacity-0 group-hover:scale-[1.06] group-hover:opacity-100',
                  ].join(' ')}
                />

                <div
                  className={[
                    'absolute inset-0 transition-opacity duration-500',
                    gate.theme === 'tiha'
                      ? 'bg-[linear-gradient(to_top,rgba(13,31,18,0.86),rgba(13,31,18,0.38),rgba(13,31,18,0.08))]'
                      : 'bg-[linear-gradient(to_top,rgba(5,18,42,0.88),rgba(5,18,42,0.42),rgba(5,18,42,0.1))]',
                  ].join(' ')}
                />

                <div className="absolute inset-x-0 bottom-0 p-7 text-white sm:p-10">
                  <h2 className="font-serif text-4xl font-normal leading-none drop-shadow-xl sm:text-5xl">
                    {gate.title}
                  </h2>

                  <div
                    className={[
                      'max-w-xl overflow-hidden transition-all duration-500 ease-out',
                      isActive
                        ? 'mt-5 max-h-72 translate-y-0 opacity-100'
                        : 'max-h-0 translate-y-4 opacity-0 group-hover:mt-5 group-hover:max-h-72 group-hover:translate-y-0 group-hover:opacity-100',
                    ].join(' ')}
                  >
                    <p className="text-base leading-relaxed text-white/90 drop-shadow-md sm:text-lg">
                     {language === 'sr' ? gate.descriptionSr : gate.descriptionEn}
                    </p>

                  </div>
                </div>
              </article>
            );
          })}
               </div>

          <div className="mx-auto mt-12 max-w-3xl rounded-[1.5rem] bg-[#e2dccf]/80 px-6 py-7 text-center shadow-[0_10px_30px_rgba(67,58,41,0.08)] ring-1 ring-[#7c6f56]/10 backdrop-blur sm:px-8">          <p className="text-base leading-relaxed text-[#3f493d] sm:text-lg">
            {t.home.seoIntroTiha}
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#3f493d] sm:text-lg">
            {t.home.seoIntroZoom}
          </p>
        </div>
        </section>
    </main>
  </>
);
}